app.service('callButton', function() {

	var handleClick = function() {
		logEvents( $(this) );
	};

	function logEvents( $button ) {
		var data = ( $button.data('event') || '' ).split("|");

		UA.pageInteraction('Zadzwoń i zamów', 'Standard');
		UA.push({
			event: 'ZadzwonZamow',
			ZZ_category: data[0],
			ZZ_brand: data[1],
			ZZ_PLU: data[2],
			ZZ_name: data[3],
			ZZ_price: data[4],
			ZZ_rootCategory: data[5],
			ZZ_foto: data[6]
		});
	}

	function setEvents() {
		$('body').on('click', '.js-call', handleClick);
	}

	function init() {
		setEvents();
	}

	return {
		init: init
	};
});